import { Component } from '@angular/core';

@Component({
  selector: 'app-cp-eb-2025',
  standalone: true,
  imports: [],
  templateUrl: './cp-eb-2025.component.html',
  styleUrl: './cp-eb-2025.component.scss'
})
export class CpEb2025Component {

}
